import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=ec973118&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=ec973118&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec973118",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec973118')) {
      api.createRecord('ec973118', component.options)
    } else {
      api.reload('ec973118', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=ec973118&scoped=true&", function () {
      api.rerender('ec973118', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21QE22aZ8kDkx/JS/teamMember.vue"
export default component.exports